module.exports = __webpack_public_path__ + "img/GoalsParents.ba19a675.svg";